import Vue from 'vue'
import axios from 'axios'

const client = axios.create({
  baseURL: process.env.ROOT_API,
  json: true
})

export default {
  async execute (obj) {
    let objQuery ={
      method:obj.method,
      url: obj.resource,
      headers: {
        Authorization: sessionStorage.getItem("pussy")
      }
    }
    if(obj.method == "get"){
      objQuery.params = obj.data
    }else{
      objQuery.data = obj.data
    }
    return client(objQuery).then(req => {
      return req.data
    })
  },
showImaging(fileId) {
  	return new Promise((resolve, reject) => {
  		let port = ""
  		if (process.env.ROOT_API.includes("viewmedonline"))
  			port = ":3027"
  		let xhr = new XMLHttpRequest();
  		xhr.open("GET", process.env.ROOT_API  + "/get_file/" + fileId)
  		xhr.setRequestHeader("Authorization", sessionStorage.getItem("pussy"))
  		xhr.responseType = "arraybuffer"
  		xhr.onload = function (e) {
  			let arraybufferView = new Uint8Array(this.response);
  			let blob = new Blob([arraybufferView], { type: "image/png" });
  			let urlCreator = window.URL || window.webkitURL;
  			let imageUrl = urlCreator.createObjectURL(blob);
  			resolve(imageUrl)
  		}
  		xhr.send()
  	})
  },
  async apiLocation() {

    let coordinates = await axios.post("https://www.googleapis.com/geolocation/v1/geolocate?key=" + process.env.API_KEY_GOOGLE_MAPS).then();
        coordinates = coordinates.data.location
    let geocode = await axios.get("https://maps.googleapis.com/maps/api/geocode/json?latlng=" + coordinates.lat + "," + coordinates.lng + "&key=" + process.env.API_KEY_GOOGLE_MAPS).then();
        geocode = geocode.data.results

    let apiLocation

    for (const item of geocode) {
      let data = item.address_components.filter(y => {
        if(y.types[0] == "country" && y.types[1] == "political"){
          apiLocation = y.short_name
        }
      })
      if(data)
        break
    }
    
    return apiLocation        

  }
}



// WEBPACK FOOTER //
// ./src/components/message/api.js